import CustomAccordion from "components/Molecules/Accordion/customAccordion";
import PageHeader from "components/Molecules/Products/AddProduct/header";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useLocation } from "react-router-dom";

export default function EditProductTemplate({ breadcrumbs, data, type }) {
  const { t } = useTranslation();
  const location = useLocation();
  const isEventService = location.pathname.includes("/events/services");
  const [expandedAccordion, setExpandedAccordion] = useState(null);
  // console.log(expandedAccordion);
  return (
    <>
      <PageHeader
        title={
          isEventService
            ? type === "edit"
              ? t("events_services.edit")
              : t("events_services.add")
            : type === "edit"
              ? t("products.breadcrumb_edit_product")
              : t("products.breadcrumb_add_product")
        }
        breadcrumbs={breadcrumbs}
      />
      <CustomAccordion
        expandedAccordion={expandedAccordion}
        setExpandedAccordion={setExpandedAccordion}
        data={data}
      />
    </>
  );
}
